import { getCurrentThread } from '@/store/reducers/UIState';
import { mkCellRefreshBtnTrackAttrs } from '@/analytics/props/litTable';
import { populateTableCells } from '@/store/thunks/UpdateTable';
import { TableColumn, TableRow } from '@/models/Table';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { Alert, Box, Button, styled } from '@mui/material';
import { ReactNode } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';

interface ErrorCellProps {
  row: TableRow;
  column: TableColumn;
}

export const ErrorCell = ({ row, column }: ErrorCellProps): ReactNode => {
  const dispatch = useAppDispatch();
  const currentThread = useAppSelector(getCurrentThread);

  const refreshCell = (): void => {
    if (!currentThread) {
      return;
    }

    dispatch(
      populateTableCells({
        threadId: currentThread.id,
        columns: [column],
        rows: [row],
      }),
    );
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start">
      <ErrorMessage variant="standard" severity="error">
        There was a problem loading this cell
      </ErrorMessage>
      <Button
        size="small"
        startIcon={<RefreshIcon />}
        onClick={() => {
          refreshCell();
        }}
        {...mkCellRefreshBtnTrackAttrs({
          columnId: column.id,
          rowId: row.id,
        })}
      >
        Refresh
      </Button>
    </Box>
  );
};

const ErrorMessage = styled(Alert)`
  background: none;
  color: ${({ theme }) => theme.color.R10.hex};
  padding: 0;

  & .MuiAlert-icon {
    margin-right: ${({ theme }) => theme.spacing(0.75)};
  }
`;
